import * as React from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { EUSLBListItem } from '../../../model/EUSLBListItem';
import { useState, useEffect } from 'react';
import { CreateEUSLB } from "../../../services/AdminServices/EUSLBService";
import { useAuth } from "react-oidc-context";
import { Toggle } from '@fluentui/react/lib/Toggle';
import { ContextualMenu, IIconProps, Stack, DialogFooter, PrimaryButton, TextField, StackItem, Modal, } from '@fluentui/react';
import { UpdateEUSLBById } from "../../../services/AdminServices/EUSLBService";
import { DefaultButton, IconButton } from '@fluentui/react/lib/Button';
import styles from './EUSLB.module.css';

function EUSLBModal(props: any) {
    const auth = useAuth();
    const [error, setError] = useState('');
    const [itemEUSLB, setitemEUSLB] = useState<EUSLBListItem>({
        key: 0,
        id: 0,
        name: '',
        active: true,
    });

    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);

    // Normally the drag options would be in a constant, but here the toggle can modify keepInBounds
    const dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu,
    };

    // Plus icon button component
    const PlusIconButton = () => <IconButton text="Add legislative basis" iconProps={{ iconName: 'Add' }} styles={{
        icon: { color: '#005A9E', fontSize: 20 },
        root: {
            width: '17px',
            alignSelf: 'end'
        },

    }} title="Add legislative basis" ariaLabel="CirclePlus" />;

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        if (name === 'name') {
            setitemEUSLB(() => ({
                ...itemEUSLB,
                [name]: value,
            }));
        } else {
            setitemEUSLB(() => ({
                ...itemEUSLB,
                ['active']: !itemEUSLB.active,
            }));
        }
    };

    // Effect to handle itemsPerPage change and update displayed items
    useEffect(() => {
        if (hideDialog) {
            setitemEUSLB(() => ({
                ...itemEUSLB,
                ['name']: '',
                ['active']: true,
            }));
            setError('');
            //reset is edit 
            props.resetIsEdit('close');
        }
    }, [hideDialog]);

    // Effect to handle itemsPerPage change and update displayed items
    useEffect(() => {
        if (props.isEdit) {
            toggleHideDialog();
            setitemEUSLB(() => ({
                ...itemEUSLB,
                ['name']: props.editItem.name ? props.editItem.name : itemEUSLB.name,

                ['active']: !!props.editItem.active,
            }));
        }
    }, [props.isEdit]);

    const handleSubmit = () => {
        if (itemEUSLB.name === '') {
            setError('Add name');
        } else {
            if (props.isEdit) {
                UpdateEUSLBById(props.editItem.encryptedId, itemEUSLB, auth.user?.id_token)
                    .then((response: any) => {
                        // Successful update, handle the response accordingly, e.g., update the user interface
                        props.handleActionResponse('edittrue');
                        console.log('EUSLB item updated successfully:', response);
                        // Update the user interface, refresh the data list, etc.
                    })
                    .catch((error: any) => {
                        props.handleActionResponse(error);
                        // If there is an error during update, handle it, e.g., display an error message
                        console.error('Error updating EUSLB item:', error);
                    });
                setError('');
                // Hide modal
                toggleHideDialog();
            } else {
                // Call service  CreateEUSLB with data from formValues
                CreateEUSLB(itemEUSLB, auth.user?.id_token).then((response) => {
                    props.handleActionResponse('createtrue');
                    console.log('Success: ', response.message);
                }).catch((error) => {
                    props.handleActionResponse(error);
                    console.error('System Error: ', error);
                });
                setError('');
                // Hide modal
                toggleHideDialog();
            }
        }
    };

    const _onRenderIDLabel = () => {
        return (
            <label
                className={styles.AddModalIDLabel}
                htmlFor="EUSLB-ID"
            >
                ID
            </label>
        );
    }

    return (
        <>
            <Modal
                isOpen={!hideDialog}
                onDismiss={toggleHideDialog}

            >
                <Stack className={styles.AddModalContainer}>
                    <StackItem className={styles.AddModalTitleRow}>
                        <div>
                            <span className={styles.AddModalTitle}>
                                {props.isEdit ? "Edit EU sectoral legislative basis" : "Add EU sectoral legislative basis"}
                            </span>
                        </div>
                        <IconButton
                            iconProps={cancelIcon}
                            ariaLabel="Close popup modal"
                            onClick={toggleHideDialog}
                        />
                    </StackItem>
                    <StackItem className={styles.modalcontent}>
                        {/*  Display the dynamic input fields */}

                        <TextField
                            type="text"
                            name="ID"
                            label="ID"
                            id="EUSLB-ID"
                            className={styles.AddModalTextField}
                            onRenderLabel={_onRenderIDLabel}
                            onChange={handleInputChange}
                            disabled
                            placeholder={props.isEdit ? props.editItem.id : "####"}
                        />
                        <TextField
                            type="text"
                            name="name"
                            label="Name"
                            errorMessage={error ? "Field is required" : ""}
                            className={styles.AddModalTextField}
                            required
                            onChange={handleInputChange}
                            value={itemEUSLB.name}
                            placeholder={props.isEdit ? props.editItem.name : "Type"}
                        />
                        <Toggle role="switch" defaultChecked={props.isEdit === false || (props.isEdit && props.editItem.active === true)}
                            onText="Active" offText="Inactive" onChange={handleInputChange} className={styles.AddModalToggle} />

                    </StackItem>
                    {/* {SelectedDialog} */}
                    <DialogFooter>
                        {/* <PrimaryButton onClick={handleDialogClose} text="Save" />
                    <DefaultButton onClick={handleDialogClose} text="Cancel" /> */}
                        <PrimaryButton text={props.isEdit ? 'Save' : 'Add'} onClick={handleSubmit} />
                        <DefaultButton text="Cancel" onClick={toggleHideDialog} />
                    </DialogFooter>
                </Stack>
            </Modal>
            <div
                role="button"
                tabIndex={0}
                onClick={toggleHideDialog}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault(); // optional for space
                        toggleHideDialog();
                    }
                }}
                className={styles.addEULBbutton}
            >
                <span> <PlusIconButton /></span>
                <span>Add legislative basis</span>
            </div>
        </>
    )
}
const cancelIcon: IIconProps = { iconName: 'Cancel' };
export default EUSLBModal;




